define([
    "./nlgNumberInputModule",
    "./nlgNumberInputDirective"
], function () {
});
